const reducerKey = 'session'
export const selectSessionUser = (state) => state[reducerKey].user
export const selectUserRole = (state) => state[reducerKey].user?.role
export const selectToken = (state) => state[reducerKey].token
